import { emptyValidator, formValidator } from "../../validators";

const supplierInvoiceValidationStatus = {
  tdhTransporter: {
    validators: [emptyValidator()],
    name: "Transporter",
  },
  tdhActionDate: {
    validators: [emptyValidator()],
    name: "From Date",
  },
  tdhNextDate: {
    validators: [emptyValidator()],
    name: "To Date",
  },
};

export const supplierInvoiceValidation = (supplierInvoiceData) => {
  return formValidator(supplierInvoiceData, supplierInvoiceValidationStatus);
};
